export enum AmbassadorPromotionLevelEnum {
  ConsumerAmbassador = 1,
  ProfessionalAmbassador = 2,
  LeadAmbassador = 3
}
